<template>
  <section class="HeaderSection gridProfiles">
    <v-data-table
      v-show="screenType == 'gridPermissions'"
      :headers="headers"
      :items="profiles"
      item-key="id"
      class="elevation-1"
      :loading="loading"
      :page.sync="options.page"
      :items-per-page="options.itemsPerPage"
      :server-items-length="totalItems"
      @update:page="getProfiles"
    >
      <!-- aqui estarão as permissões -->
      <template v-slot:[`item.permission`]="{ item }">
        <!-- <pre>{{ item }}</pre> -->
        <!-- {{ item.abilities ? item.abilities.length : 0 }} habilidades -->
        <Permission
          v-if="item"
          :resource="item"
          :abilities="item.abilities || []"
        />
      </template>

      <template v-slot:[`item.deleted_at`]="{ item }">
        <v-chip :color="item.deleted_at ? 'red' : '#017d59'" dark class="chip">
          {{ item.deleted_at ? "Inativo" : "Ativo" }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :actions="actions">
          <v-btn
            class="border__radius-10"
            color="primary"
            small
            depressed
            style="margin-top: 10px; width: 190px"
            @click="openEditProfile(item)"
          >
            <v-icon size="18px" class="mr-2">mdi-pencil</v-icon>
            EDITAR PERFIL
          </v-btn>
          <v-btn
            class="border__radius-10"
            :color="item.deleted_at ? '#017d59' : 'red'"
            small
            outlined
            depressed
            style="margin-top: 10px; width: 190px"
            :disabled=" item.id === 1"
            @click="toggleProfileStatus(item)"
          >
            <v-icon class="mr-2" x-small>
              {{ item.deleted_at ? "mdi-cancel" : "mdi-check-circle" }}
            </v-icon>
            {{ item.deleted_at ? "Ativar" : "Desativar" }}
          </v-btn>

          <v-btn
            class="border__radius-10"
            color="#1876D2"
            small
            outlined
            depressed
            style="margin-top: 10px; width: 190px"
            @click="openChangePermissions(item)"
          >
            <v-icon class="mr-2" x-small> mdi-shield-edit </v-icon>
            Conceder Permissão
          </v-btn>
        </Menu>
        <!-- :systemAbilities="systemAbilities"
        @saved="handleSave"
        @close="handleClose"
        @error="handleError" -->
      </template>
    </v-data-table>

    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>Editar Perfil</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editProfile.profile_name"
            label="Nome do Perfil"
            outlined
            dense
          />
          <v-text-field
            v-model="editProfile.profile_description"
            label="Descrição do Perfil"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveEditProfile">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Componente de Permissões -->
    <!-- selectedProfile → Perfil atual
    systemAbilities → Todas as habilidades do sistema
    abilities → IDs das habilidades já marcadas -->
    <ChangePermission
      ref="changePermission"
      v-show="screenType === 'changePermissions'"
      :selectedProfile="selectedProfile"
      :systemAbilities="systemAbilities"
      :abilities="selectedPermissions"
      @updateGrid="getProfiles"
      @close="screenType = 'gridPermissions'"
    />
    <SuccessComponent
      v-if="showSuccess"
      :message="successMessage"
      @close="showSuccess = false"
    />
    <ErrorComponent
      v-if="showError"
      :message="errorMessage"
      @close="showError = false"
    />
  </section>
</template>

<script>
import ChangePermission from "./ChangePermission.vue";
import Permission from "./Permission.vue";
import SuccessComponent from "../alerts/Success-component.vue";
import ErrorComponent from "../alerts/Error-component.vue";
import Menu from "../../widgets/grids/actions/Menu.vue";
import axios from "@/axios";

export default {
  name: "GridProfiles",

  components: {
    Permission,
    ChangePermission,
    SuccessComponent,
    ErrorComponent,
    Menu,
  },

  watch: {
    options: {
      handler() {
        this.getProfiles();
      },
      immediate: true,
    },

    deep: true,
  },

  data: () => ({
    editDialog: false,
    editProfile: {
      id: null,
      profile_name: "",
      profile_description: "",
    },
    // profiles: [
    profiles: [],
    selectedProfile: null, // perfil selecionado
    allAbilities: [], // todas as habilidades possíveis

    systemAbilities: [],
    selectedPermissions: [], // IDs das habilidades já vinculadas

    loading: false,

    showSuccess: false,
    showError: false,
    successMessage: "",
    errorMessage: "",

    options: { page: 1, itemsPerPage: 10 },
    itemsPerPage: 10,
    page: 1,
    totalItems: 0,

    screenType: "gridPermissions",

    // changePermissionDialog: false,
    // selectedProfileForPermission: null,
    // dialogActions: false,

    headers: [
      { text: "Nome", value: "profile_name" },
      { text: "Permissão", value: "permission" },
      { text: "Status", value: "deleted_at" },
      { text: "Ações", value: "actions", sortable: false },
    ],

    actions: [
      // {
      //   name: "Editar",
      //   type: "modal",
      // },
      // {
      //   name: "Ativar/Desativar",
      //   type: "modal",
      // },
    ],
  }),

  mounted() {
    // Chama a função automaticamente quando o componente carrega
    this.getProfiles();
  },

  methods: {
    openEditProfile(item) {
      this.editProfile = { ...item };
      this.editDialog = true;
    },

    saveEditProfile() {
      // const updatedProfile = { ...item, profile_name: "Novo Nome do Perfil" };
      const updatedProfile = {
        profile_name: this.editProfile.profile_name,
        profile_description: this.editProfile.profile_description,
      };
      axios
        .put(`/profile/update/${this.editProfile.id}`, updatedProfile)

        .then((response) => {
          this.$swal({
            icon: "success",
            title: response.data.message || "Perfil atualizado com sucesso!",
            timer: 2000,
            showConfirmButton: false,
          });
          this.editDialog = false;
          this.getProfiles();
          // Atualiza a lista
          // this.getProfiles();
        })
        .catch((error) => {
          console.error("Erro ao editar perfil:", error);
          this.$swal({
            icon: "error",
            title: "Erro ao atualizar perfil",
            text: error?.response?.data?.message || error.message,
          });
        });
    },
    async toggleProfileStatus(item) {
      try {
        // if(item.id_profile_user === 1){
        //   this.$swall({
        //     icon: "Warning",
        //     title: "Este perfil não pode ser desativado!",
        //     text: "Esse perfil é essencial para o sistema",
        //     timer:3000,
        //     showConfirmButton: false
        //   });
        //   return
        // }
        if (!item.deleted_at) {
          // Se já está ativo → desativar
          await axios.delete(`/profile/delete/${item.id}`);
        } else {
          // Se está inativo → ativar
          await axios.put(`/profile/restore/${item.id}`);
        }
        await this.getProfiles();
        // Atualiza o estado localmente para refletir na UI
        // item.profile_active = !item.profile_active;
        this.$swal({
          icon: "success",
          title: item.deleted_at
            ? "Perfil desativado com sucesso!"
            : "Perfil ativado com sucesso!",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          icon: "error",
          title: "Erro ao atualizar status do perfil",
          text: error?.response?.data?.message || error.message,
        });
      }
    },

    // modal de confirmação
    async toggleProfileStatusConfirmed() {
      this.confirmationDialog = false; // Fecha o modal
      const updatedProfile = {
        ...this.profileToToggle,
        profile_active: !this.profileToToggle.profile_active,
      };
      try {
        await axios.put(
          `/profile/${updatedProfile.profile_id}`,
          updatedProfile
        );
        this.showSuccess = true;
        this.successMessage = `Perfil ${
          updatedProfile.profile_active ? "ativado" : "desativado"
        } com sucesso!`;
        this.getProfiles(); // Recarrega a lista de perfis
      } catch (error) {
        this.showError = true;
        this.errorMessage = "Erro ao alterar o status do perfil!";
        console.error(error);
      }
    },

    async getProfiles() {
      this.loading = true;
      try {
        const response = await axios.get("/profile/abilities", {
          params: {
            page: this.options.page,
            per_page: this.options.itemsPerPage,
          },
        });

        this.profiles = response.data;
        this.totalItems = response.data.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("Erro ao listar perfis com habilidades:", error);
      }

      // try {
      //   const [profilesResponse, abilitiesResponse] = await Promise.all([
      //     //busca a lista de perfis
      //     axios.get("/profile", {
      //       params: {
      //         page: this.page,
      //         per_page: this.itemsPerPage,
      //       },
      //     }),
      //     //busca as habilidades
      //     axios.get("/ability"),
      //   ]);
      //   console.log(profilesResponse.data);

      //   this.profiles = profilesResponse.data.data; // dados da página atual
      //   this.totalItems = profilesResponse.data.total; // total do servidor
      //   this.systemAbilities = abilitiesResponse.data;
      //   this.numberOfPages = profilesResponse.data.last_page;

      //   this.loading = false;
      // } catch (error) {
      //   this.loading = false;
      //   console.error("Erro ao listar registros:", error);
      // }
    },
    async openChangePermissions(profile) {
      this.selectedProfile = profile;

      //habilidades associadas ao perfil
      this.selectedPermissions = profile?.abilities
        ? profile.abilities.map((a) => a.id)
        : [];

      // carrega todas as habilidades do sistema (se ainda não tiver carregado)
      if (!this.systemAbilities.length) {
        try {
          const response = await axios.get("/ability"); // rota para pegar todas as habilidades
          this.systemAbilities = response.data;
        } catch (error) {
          console.error("Erro ao carregar habilidades do sistema:", error);
        }
      }
      // this.systemAbilities = this.allAbilities;

      // Alterna para a tela de ChangePermissions
      this.screenType = "changePermissions";

      // toggleProfileStatus(profile) {
      //   this.profileToToggle = profile;
      //   this.confirmationDialog = true;
      // },

      // deletePermission(abilityId) {
      //   axios.delete(`/api/ability/${abilityId}`);
      //   this.showSuccess = true;
      //   this.successMessage = "Permissão deletada com sucesso!";
      //   this.getProfiles(); // Recarregar a lista de perfis após exclusão
      //   this.showError = true;
      //   this.errorMessage = "Erro ao deletar permissão!";
      //   console.error("Erro ao deletar permissão:");
      // },

      // Aqui, você pode adicionar o método que será chamado quando o usuário clicar em "Ativar/Desativar"
      // handleAction(action, profile) {
      //   if (action.name === "Ativar/Desativar") {
      //     this.toggleProfileStatus(profile);
      //   } else if (action.name === "Editar") {
      //     this.openChangePermissions(profile);
      //   }
      // },

      //   try {
      //     const response = await axios.get(
      //       `/profile/${profile.profile_id}/abilities`
      //     );
      //     this.selectedPermissions = response.data;
      //   } catch (error) {
      //     console.error("Erro ao buscar habilidades do perfil:", error);
      //     this.selectedPermissions = [];
      //   }
    },
  },
};
</script>

<style scoped>
.chip {
  border-radius: 4px;
  padding: 0 8px;
  height: 28px;
  font-weight: 500;
}
.gridProfiles {
  /* display: flex;
  flex-direction: column;
  gap: 15px; */
}

.menu-acoes {
  border-radius: 12px;
  padding: 10px;
  min-width: 220px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

.menu-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
  justify-content: center;
  padding: 5px 0;
}

.btn-editar {
  background: #f5f5f5;
  border-radius: 8px;
  margin: 5px 0;
  font-weight: 600;
  color: #333 !important;
}

.btn-editar:hover {
  background: #e0e0e0;
}

.btn-desativar {
  background: #ffebee;
  border-radius: 8px;
  margin: 5px 0;
  font-weight: 600;
  color: #c62828 !important;
}

.btn-desativar:hover {
  background: #ffcdd2;
}

.btn-permissao {
  margin-top: 10px;
  border: 1px solid #1876d2;
  border-radius: 8px;
  font-weight: 600;
  color: #1876d2 !important;
  text-transform: uppercase;
}

.btn-permissao:hover {
  background: #e3f2fd;
}
</style>
